// src/components/Dashboard/charts/CompletionTimeByMonthChart.tsx
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { format, parse } from "date-fns";
import { Empty } from "antd";

interface CompletionTimeData {
  month: string;
  avg_days: number;
  count: number;
}

interface CompletionTimeByMonthChartProps {
  data: CompletionTimeData[];
}

const CompletionTimeByMonthChart: React.FC<CompletionTimeByMonthChartProps> = ({
  data,
}) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex justify-center items-center h-64">
        <Empty description="No completion time data available" />
      </div>
    );
  }

  // Format the data for the chart
  const formattedData = data.map((item) => {
    // Parse the YYYY-MM format correctly
    const date = parse(item.month, "yyyy-MM", new Date());

    return {
      ...item,
      name: format(date, "MMM yyyy"),
      avg_days: Number(item.avg_days.toFixed(1)),
    };
  });

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 shadow-md rounded-md">
          <p className="font-medium text-gray-600">{label}</p>
          <p className="text-blue-600">
            Tiempo Promedio Completado:{" "}
            <span className="font-bold">{payload[0].value}</span> días
          </p>
          <p className="text-gray-600">
            Folders completados:{" "}
            <span className="font-bold">{payload[0].payload.count}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="h-64 w-full">
      <ResponsiveContainer>
        <BarChart
          data={formattedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis
            dataKey="name"
            tick={{ fill: "#6b7280" }}
            tickLine={{ stroke: "#e5e7eb" }}
            axisLine={{ stroke: "#e5e7eb" }}
          />
          <YAxis
            tick={{ fill: "#6b7280" }}
            tickLine={{ stroke: "#e5e7eb" }}
            axisLine={{ stroke: "#e5e7eb" }}
            label={{
              value: "Días",
              angle: -90,
              position: "insideLeft",
              fill: "#6b7280",
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar
            dataKey="avg_days"
            name="Tiempo Promedio Completado (Días)"
            fill="#3b82f6"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompletionTimeByMonthChart;
